import React, { useState } from "react";
import { Helmet } from "react-helmet";
import FsLightbox from "fslightbox-react";
import "../../../App.css"
import image1 from "../../../Img/Proyectos/ProyectosCasasDescanso/Casa9/61ce1275fb5d2659450f5afb_C9.Chacala.1.jpg"
import image2 from "../../../Img/Proyectos/ProyectosCasasDescanso/Casa9/61ce12e85d1eb263e6835024_C9.Chacala.3.jpg"
import image3 from "../../../Img/Proyectos/ProyectosCasasDescanso/Casa9/61ce12e77957d3144df37faa_C9.Chacala.4.jpg"
import image4 from "../../../Img/Proyectos/ProyectosCasasDescanso/Casa9/61ce12e78d0eeb51b4db7d38_C9.Chacala.5.jpg"
import image5 from "../../../Img/Proyectos/ProyectosCasasDescanso/Casa9/61ce12e75d1eb21112835021_C9.Chacala.6.jpg"
import image6 from "../../../Img/Proyectos/ProyectosCasasDescanso/Casa9/61ce12e80a0f504bd2f40c02_C9.Chacala.7.jpg"
import image7 from "../../../Img/Proyectos/ProyectosCasasDescanso/Casa9/61ce12e736264601dd28103e_C9.Chacala.8.jpg"
import image8 from "../../../Img/Proyectos/ProyectosCasasDescanso/Casa9/61ce12e87957d37168f37fae_C9.Chacala.9.jpg"


function ProyectoCasa9() {

    const [toggler, setToggler] = useState(false);

    const [lightboxController, setLightboxController] = useState({
        toggler: false,
        slide: 1
    });

    function openLightboxOnSlide(number) {
        setLightboxController({
            toggler: !lightboxController.toggler,
            slide: number
        });
    }


    return (
        <>

            <Helmet>
                <title>Playa y Montaña - Casa 9</title>
            </Helmet>

            <FsLightbox
                toggler={lightboxController.toggler}

                sources={[
                    image1, image2, image3, image4, image5, image6, image7, image8
                ]}

                slide={lightboxController.slide}
            />

            <div className="container col-12 py-5">
                <div className="d-flex">
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a href="/proyectos-casas-de-descanso">Playa y Montaña</a></li>
                            <li class="breadcrumb-item active" aria-current="page">Casa 9</li>
                        </ol>
                    </nav>
                </div>
                <h1 className="py-2 m-0 p-0">Casa 9</h1>
                <h6 className="py-2 m-0 p-0">Chacala, Nay.<h6>2015</h6></h6>
            </div>

            <div className="container position-relative">
                <img onClick={() => openLightboxOnSlide(1)} type="button" src={image1} className="w-100" alt="..." height={650} />
            </div>

            <div className="container">
                <div className="row gy-4 mt-1">

                    <div className="col-lg-4 col-md-12">
                        <img onClick={() => openLightboxOnSlide(2)}
                            src={image2}
                            className="w-100 h-100"
                            alt="imagen proyecto"
                        />
                    </div>

                    <div className="col-lg-4 col-md-12">
                        <img onClick={() => openLightboxOnSlide(3)}
                            src={image3}
                            className="w-100 h-100"
                            alt="imagen proyecto"
                        />
                    </div>

                    <div className="col-lg-4 col-md-12">
                        <img onClick={() => openLightboxOnSlide(4)}
                            src={image4}
                            className="w-100 h-100"
                            alt="imagen proyecto"
                        />
                    </div>

                    <div className="col-lg-4 col-md-12">
                        <img onClick={() => openLightboxOnSlide(5)}
                            src={image5}
                            className="w-100 h-100"
                            alt="imagen proyecto"
                        />
                    </div>


                    <div className="col-lg-4 col-md-12">
                        <img onClick={() => openLightboxOnSlide(6)}
                            src={image6}
                            className="w-100 h-100"
                            alt="imagen proyecto"
                        />
                    </div>


                    <div className="col-lg-4 col-md-12">
                        <img onClick={() => openLightboxOnSlide(7)}
                            src={image7}
                            className="w-100 h-100"
                            alt="imagen proyecto"
                        />
                    </div>

                    <div className="col-lg-4 col-md-12">
                        <img onClick={() => openLightboxOnSlide(8)}
                            src={image8}
                            className="w-100 h-100"
                            alt="imagen proyecto"
                        />
                    </div>




                </div>
            </div>
        </>
    );
}

export default ProyectoCasa9;
